import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_ONBOARDING_STEP } from '../../redux/actions/types';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';
import { useLocation } from 'react-router-dom';
import { scrollToFormAndSlide } from '../../utils/scrollUtils';

  const NewLogo = ({navigateToHome, setLoginModal, handleScroll, dummyRef, formScrollRef, formSwiperRef, handleFormSlide , loginEmailRef}) => {
  const dispatch = useDispatch();
  const step = useSelector((store) => store?.onBoarding?.step);
  const maxStep = useSelector((store) => store?.onBoarding?.maxStep);
  const isLoading = useSelector((store) => store?.onBoarding?.isLoading);
  const location = useLocation();
  const isOnBoarding = location.pathname.includes('/onboarding');
  const isLandingPage = location.pathname === '/';
  const handleStepBack = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_BACK_BUTTON_CLICKED);
    dispatch({type: SET_ONBOARDING_STEP, payload: step - 1});
  }

  const handleStepForward = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FORWARD_BUTTON_CLICKED);
    dispatch({type: SET_ONBOARDING_STEP, payload: step + 1});
  }



  return (
  <div className='relative w-full'>
    {step > 1 && !isLoading && isOnBoarding && <FontAwesomeIcon icon={faArrowLeft} onClick={handleStepBack} className='text-lg text-white font-semibold absolute top-2 left-0 cursor-pointer'/>}
    {step >= 1 && step < maxStep && !isLoading && isOnBoarding && <FontAwesomeIcon icon={faArrowRight} onClick={handleStepForward} className='text-lg text-white font-semibold absolute top-2 right-0 cursor-pointer'/>}
      <div className={` relative w-fit  text-white  ${(isLandingPage && window.innerWidth < 768) ? 'flex justify-start' : 'flex items-center mx-auto' } gap-2`}>
        <div className='flex items-center gap-2'>
          <div className='w-fit bg-white/10 flex items-center p-2 rounded-md gap-2' onClick={navigateToHome}>
              <img src="https://assets.learntube.ai/files/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449" loading="eager" alt="" width={24} height={24} className='w-6 h-6'/>
              <p className='font-medium text-xs'>LearnTube.ai</p>
          </div>
          <div className='h-[36px] w-[2px] bg-white/20' />
          <div className='flex flex-col items-center'>
              <p className='text-[10px] text-white/50'>backed by</p>
              <div className='flex gap-1 items-center'>
              <img src="https://assets.learntube.ai/files/post-payment-updates/use2460.svg?updatedAt=1728356838222" alt="" width={40} height={13} className='w-10 h-auto' />
              <img src="https://assets.learntube.ai/files/post-payment-updates/text3075.svg?updatedAt=1728356926579" alt="" width={64} height={13} className='w-16 h-auto' />
              </div>
          </div>
        </div>
       
    </div>
    {isLandingPage &&  <div className='underline underline-offset-2 cursor-pointer text-[14px] text-[#7FC241] absolute right-0 top-2' onClick={() => {handleScroll(dummyRef); handleFormSlide(formSwiperRef, 0);
     
     setTimeout(() => {
      loginEmailRef?.current?.focus()
     },1000);
      
     }}>Login</div>}
</div>
  )
}

export default NewLogo